function initProfileImageEdit () {
    const $removeButton = $('.js-remove-profile-image')
    $removeButton.on('click', function removePreview () {
        const $parentContainer = $(this).closest('.js-file-input-container')
        const $previewImage = $parentContainer.find('.js-preview-image')
        const $input = $parentContainer.find('input')
        const $hiddenInput = $previewImage.find('input')

        $input.removeClass('u-hidden')
        $previewImage.addClass('u-hidden').removeClass('position-relative d-inline-block')
        $hiddenInput.val(0)
    })
}

export const initForms = () => {
    initProfileImageEdit()
}
